import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ShieldCheck, Trash2, Mail, Settings } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function DataDeletion() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!code) return;
    fetch(`${API}/api/data-deletion/status?code=${encodeURIComponent(code)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then(setStatus)
      .catch(() => setStatus(null));
  }, [code]);

  return (
    <div className="min-h-screen bg-deep-navy px-4 py-10 sm:py-16" data-testid="data-deletion-page">
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="text-2xl font-bold text-white inline-block mb-8">
          GritClicks<span className="text-lime">.com</span>
        </Link>

        {code && (
          <div className="mb-8 rounded-xl border border-lime bg-lime/10 p-4" data-testid="deletion-confirmation-banner">
            <p className="text-white font-bold mb-1">Deletion request received</p>
            <p className="text-sm text-light-gray">
              Confirmation code: <span className="text-lime font-mono font-bold">{code}</span>
              {status && <> · Status: <span className="text-lime font-semibold">{status.status}</span></>}
            </p>
          </div>
        )}

        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-6 flex items-center gap-3">
          <ShieldCheck className="text-lime shrink-0" size={32} /> How to delete your data
        </h1>

        <p className="text-light-gray leading-relaxed mb-8">
          You can delete your GritClicks account and all the data we store about you at any time.
        </p>

        <div className="space-y-4 mb-8">
          <div className="rounded-xl border border-divider bg-card-bg p-5 flex gap-4">
            <Settings className="text-lime shrink-0 mt-0.5" size={20} />
            <div>
              <p className="text-white font-bold mb-1">In the app</p>
              <p className="text-sm text-light-gray">
                Go to <Link to="/account" className="text-lime hover:underline font-semibold">Settings → Delete my account</Link>.
              </p>
            </div>
          </div>
          <div className="rounded-xl border border-divider bg-card-bg p-5 flex gap-4">
            <Mail className="text-lime shrink-0 mt-0.5" size={20} />
            <div>
              <p className="text-white font-bold mb-1">By email</p>
              <p className="text-sm text-light-gray">
                Email us at <a href="mailto:info@gritclicks.com" className="text-lime hover:underline font-semibold" data-testid="deletion-email-link">info@gritclicks.com</a> and
                we'll remove everything within 30 days.
              </p>
            </div>
          </div>
        </div>

        <div className="rounded-xl border border-divider bg-black p-5 flex gap-4">
          <Trash2 className="text-orange shrink-0 mt-0.5" size={20} />
          <p className="text-sm text-light-gray leading-relaxed">
            When you delete your account, we permanently remove your profile and disconnect your ad accounts.
            Your Google and Facebook ad accounts themselves always stay yours — deleting GritClicks only removes
            what GritClicks stored.
          </p>
        </div>
      </div>
    </div>
  );
}
